<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="$t('requests')"
          :directory="$t('')"
          :icon="'trello'"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            @click="returnPage()"
          >
            {{ $t("back") }}
          </button>
        </div>
      </div>
      <div class="col-md-12">
        <h5>{{ $t("type_request") }}: {{ app_type }}</h5>
        <app-tab :tabs="tabsHorizontal" :accreditation-application-id="accreditationApplicationId" type="horizontal" />
      </div>
    </div>
  </div>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import * as actions from "../../apiUrl";
export default {
  name: "Form",
  mixins: [FormMixin],
  components: {},
  props: {
    accreditationApplicationId: String,
  },
  data() {
    return {
      app_type: "",
      icon: "settings",
      tabsHorizontal: [
        {
          icon: "briefcase",
          name: this.$t("general"),
          component: "form-general-review",
          permission: "",
        },
        {
          icon: "home",
          name: this.$t("organization"),
          component: "form-organization-review",
          permission: "",
        },
        {
          icon: "send",
          name: this.$t("request"),
          component: "form-requets-review",
          permission: "",
        },
        {
          icon: "align-center",
          name: this.$t("details"),
          component: "form-detail-review",
          permission: "",
        },
        {
          icon: "paperclip",
          name: this.$t("annexes"),
          component: "form-annexes-review",
          permission: "",
        },
        {
          icon: "award",
          name: this.$t("compliance_commitment"),
          component: "form-commitment-review",
          permission: "",
        },
        {
          icon: "file-minus",
          name: this.$t("send_request"),
          component: "form-sendrequest-review",
          permission: "",
        },
      ],
    };
  },
  created() {
    this.$store.state.accreditation.id = this.accreditationApplicationId;
    this.data();
  },
  methods: {
    returnPage() {
      window.location.href = "/accreditationreview/accreditations";
    },
    data() {
      let url = `${actions.ACCREDITATIONS_APPLICATIONS}/form/${this.accreditationApplicationId}`;
      this.axiosGet(url)
        .then((response) => {
          if (response.status == 200) {
            const {
              accreditation_area: area,
              accreditation_activity: activity,
              accreditation_type: type,
            } = response.data.app;
            this.app_type = `${area.name} - ${activity.name}`;
            this.$store.state.accreditation.app = response.data.app;
          }
        })
        .catch((error) => {
          console.log("Form: " + error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
  },
};
</script>
